"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListGroup = exports.GroupDivider = exports.GroupHeader = void 0;
var react_1 = __importDefault(require("react"));
var Typo2_1 = require("../../Typo2");
var Divider_1 = require("../../Divider");
var themes_1 = require("../../../themes");
var styled_components_1 = __importDefault(require("styled-components"));
var ListItem_1 = require("./ListItem");
exports.GroupHeader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 0.4rem 0.8rem;\n  color: ", ";\n"], ["\n  padding: 0.4rem 0.8rem;\n  color: ", ";\n"])), themes_1.colors.grey50);
exports.GroupDivider = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0.4rem 0 0.8rem 0;\n"], ["\n  margin: 0.4rem 0 0.8rem 0;\n"])));
var ListGroup = function (_a) {
    var group = _a.group, index = _a.index, value = _a.value, focussedOp = _a.focussedOp, scrollFocussedOpIntoView = _a.scrollFocussedOpIntoView, handleSelect = _a.handleSelect, optionsClassName = _a.optionsClassName, invert = _a.invert, S = _a.S, observerRef = _a.observerRef, isMulti = _a.isMulti, isTagsStyle = _a.isTagsStyle, setFocusSelectTagsInput = _a.setFocusSelectTagsInput, setSearchString = _a.setSearchString, setSearchBarFocus = _a.setSearchBarFocus;
    return (react_1.default.createElement("div", null,
        index > 0 && (react_1.default.createElement(exports.GroupDivider, null,
            react_1.default.createElement(Divider_1.Divider, null))),
        react_1.default.createElement(exports.GroupHeader, null,
            react_1.default.createElement(Typo2_1.UI_TAG, null, group.display)),
        group.options.map(function (option, idx) { return (react_1.default.createElement(ListItem_1.ListItem, { key: option.value, option: option, isSelected: (!option.loading && (value === null || value === void 0 ? void 0 : value.value) === option.value), isFocussed: focussedOp === idx, index: idx, scrollFocussedOpIntoView: scrollFocussedOpIntoView, handleSelect: function () {
                if (!option.loading) {
                    handleSelect(option);
                    if (setSearchString)
                        setSearchString("");
                    if (setSearchBarFocus)
                        setSearchBarFocus(true);
                    if (setFocusSelectTagsInput)
                        setFocusSelectTagsInput(true);
                }
            }, optionsClassName: optionsClassName, invert: invert, S: S, observerRef: group.options.length === idx + 1 ? observerRef : null, isMulti: isMulti, isTagsStyle: isTagsStyle, value: value })); })));
};
exports.ListGroup = ListGroup;
var templateObject_1, templateObject_2;
